export default __webpack_public_path__ + "static/media/bihorel11.b27c5974.jpg";